import { log } from "@app/app/services/log";

import { configManager } from "../configuration/ConfigManager";
import { PendingApiAdapter } from "./adapters/api/PendingApiAdapter";
import { ValidationApiAdapter } from "./adapters/api/ValidationApiAdapter";
import { WindowApiAdapter } from "./adapters/api/WindowApiAdapter";
import { ApiAdapter, UrlAdapter } from "./adapters/types";
import { BasicUrlAdapter } from "./adapters/url/BasicUrlAdapter";
import { hostApiMethods, privateApiMethods } from "./api/methods";

// HostManager is a singleton class that manages the host api and url adapters
// It is responsible for initializing the api adapters and the url adapter
// in the future it can change the adapters based on the host environment
class HostManager {
    public apiAdapter: ApiAdapter;
    public privateApiAdapter: ApiAdapter;
    public urlAdapter: UrlAdapter;

    public constructor() {
        log.debug("Initializing HostManager");

        // Initialize the url adapter
        this.urlAdapter = new BasicUrlAdapter();
        log.debug("BasicUrlAdapter initialized");

        this.apiAdapter = this.constructHostApi();
        log.debug("API methods exposed:", { methodCount: hostApiMethods.length });

        this.privateApiAdapter = this.constructPrivateApi();
        log.debug("API private methods exposed:", { methodCount: privateApiMethods.length });
    }

    private constructHostApi() {
        console.log("HostManager constructor", WindowApiAdapter);

        // Mount api to the window object
        const windowApiAdapter = new WindowApiAdapter([
            configManager.config.core.globalVendorNamespace,
            configManager.config.core.globalAppNamespace,
        ]);
        log.debug("WindowApiAdapter initialized with namespace:", {
            namespace: `${configManager.config.core.globalVendorNamespace}.${configManager.config.core.globalAppNamespace}`,
        });

        // Validate any incoming api calls
        const validationApiAdapter = new ValidationApiAdapter(windowApiAdapter);
        log.debug("ValidationApiAdapter initialized");

        // Cache the api calls until a handler is registered
        const pendingApiAdapter = new PendingApiAdapter(validationApiAdapter);
        log.debug("PendingApiAdapter initialized");

        // Initialize the api adapters
        pendingApiAdapter.exposeApi(hostApiMethods);

        return pendingApiAdapter;
    }

    private constructPrivateApi() {
        const windowPrivateApiAdapter = new WindowApiAdapter([
            configManager.config.core.globalVendorNamespace,
            "_" + configManager.config.core.globalAppNamespace,
        ]);
        log.debug("WindowApiAdapter initialized with namespace:", {
            namespace: `${configManager.config.core.globalVendorNamespace}.${configManager.config.core.globalAppNamespace}`,
        });

        windowPrivateApiAdapter.exposeApi(privateApiMethods);

        return windowPrivateApiAdapter;
    }
}

// Export a singleton instance
export const hostManager = new HostManager();
